var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-input',{attrs:{"autofocus":false,"label-text":_vm.labelText,"placeholder":_vm.placeholder,"value":_vm.value,"onInput":_vm.onInputInternal,"inputType":'email',"error":_vm.error,"error-message":_vm.emailErrorLabel}})
}
var staticRenderFns = []

export { render, staticRenderFns }